import { RadioOption } from '@sdir/sds';
import { messages } from '../localization';

export const DEFAULT_LANG = 'nb';

export const getLanguageOptions = (): RadioOption[] => {
  const options: RadioOption[] = [];
  Object.keys(messages).forEach((key) => {
    if (messages[key]?.language) {
      options.push({ label: messages[key]?.language, value: key });
    }
  });
  return options;
};

export const getCurrentLanguageOutsideProvider = (): string => {
  const languageOptions = getLanguageOptions();
  const urlSegments = window.location.href?.split('/');
  let langCode = DEFAULT_LANG;
  urlSegments?.forEach((u) => {
    const match = languageOptions.find((o) => o.value === u);
    if (match) langCode = match?.value;
  });
  return langCode;
};

// Get the new current route when switching language
export const getCorrespondingLanguageRoute = (currentLang: string, newLang: string): string => {
  const currentUrl = window.location.href || '';
  const newLanguage = newLang || currentLang;
  const hasHash = !!(currentUrl.indexOf('/#/') !== -1);

  let newUrl = currentUrl;
  if (currentLang !== DEFAULT_LANG) {
    const replacement = newLanguage !== DEFAULT_LANG ? `/${newLanguage}/` : '/';
    newUrl = newUrl.replace(`/${currentLang}/`, replacement);
  } else {
    newUrl = hasHash ? newUrl.replace('/#/', `/#/${newLanguage}/`) : `${newUrl}#/${newLang}/`;
  }
  return newUrl;
};

// Format a given route to a specific language
export const getRouteForLanguage = (language: string, route: string): string => {
  return language === DEFAULT_LANG ? route : `/${language}${route}`;
};

export const navigateDirectlyByUrl = (route: string): void => {
  window.location.href = route;
  window.location.reload();
};

export const getReceiptLanguage = (language: string) => {
  if (language === 'en') return 'EN';
  if (['no', 'nb', 'nn'].includes(language)) return 'NO';
  return 'EN';
};
